/* Pushpin map markers (Phase 97) - drawn to match Steve's reference photo:
   a round coloured ball head on a narrow dark tapering stem, with the pointed
   tip landing EXACTLY on the mapped (generalized) location.

   Status colours (locked by Steve, accessible tones):
     Red    - New / Open
     Orange - In Progress
     Blue   - Awaiting City Response
     Green  - Resolved
   Colour is never the only indicator: popups always show the status in text. */
import React from 'react';
import L from 'leaflet';

export const STAGE_PIN_COLORS = {
  open: '#b91c1c',                    // Red - New/Open
  in_progress: '#ea580c',             // Orange - In Progress
  awaiting_city_response: '#2563eb',  // Blue - Awaiting City Response
  resolved: '#16a34a',                // Green - Resolved
};

export const STAGE_LEGEND = [
  { stage: 'open', label: 'New / Open', color: STAGE_PIN_COLORS.open },
  { stage: 'in_progress', label: 'In Progress', color: STAGE_PIN_COLORS.in_progress },
  { stage: 'awaiting_city_response', label: 'Awaiting City Response', color: STAGE_PIN_COLORS.awaiting_city_response },
  { stage: 'resolved', label: 'Resolved', color: STAGE_PIN_COLORS.resolved },
];

// The pin tip is at (15, 41) in the 30x42 viewBox -> iconAnchor [15, 41]
const pushpinSvg = (color, size = 34) => `
<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${Math.round(size * 1.4)}" viewBox="0 0 30 42"
     style="filter: drop-shadow(0 2px 2px rgba(15,23,42,0.45)); overflow: visible;">
  <polygon points="13.4,19 16.6,19 15.35,39 15,41" fill="#334155" stroke="#0f172a" stroke-width="0.5" />
  <circle cx="15" cy="11.5" r="9.6" fill="${color}" stroke="#ffffff" stroke-width="1.6" />
  <circle cx="15" cy="11.5" r="9.6" fill="none" stroke="rgba(15,23,42,0.35)" stroke-width="0.8" />
  <ellipse cx="11.8" cy="8.2" rx="3.1" ry="2.1" fill="rgba(255,255,255,0.55)" transform="rotate(-25 11.8 8.2)" />
</svg>`;

const iconCache = {};

export const pushpinIcon = (color, size = 34) => {
  const key = `${color}-${size}`;
  if (!iconCache[key]) {
    const h = Math.round(size * 1.4);
    iconCache[key] = L.divIcon({
      className: 'w8-pushpin',
      html: pushpinSvg(color, size),
      iconSize: [size, h],
      // The pointed bottom of the pin marks the exact mapped location
      iconAnchor: [size / 2, h - 1],
      popupAnchor: [0, -(h - 10)],
    });
  }
  return iconCache[key];
};

/* Small inline pushpin used in the Status Legend so the legend swatches look
   exactly like the pins on the map. */
export const LegendPushpin = ({ color }) => (
  <svg width="16" height="22" viewBox="0 0 30 42" aria-hidden="true" className="shrink-0" style={{ filter: 'drop-shadow(0 1px 1px rgba(15,23,42,0.4))' }}>
    <polygon points="13.4,19 16.6,19 15.35,39 15,41" fill="#334155" stroke="#0f172a" strokeWidth="0.5" />
    <circle cx="15" cy="11.5" r="9.6" fill={color} stroke="#ffffff" strokeWidth="1.6" />
    <circle cx="15" cy="11.5" r="9.6" fill="none" stroke="rgba(15,23,42,0.35)" strokeWidth="0.8" />
    <ellipse cx="11.8" cy="8.2" rx="3.1" ry="2.1" fill="rgba(255,255,255,0.55)" transform="rotate(-25 11.8 8.2)" />
  </svg>
);
